// src/components/AssetUploader.js

import React from 'react';
import { Stack, Collapse } from '@mui/material';
import AssetUploadDropzone from './AssetUploadDropzone';
import AssetUploadPreviewVerify from './AssetUploadPreviewVerify';

export default function AssetUploader({
  files,
  onSetFiles,
  onRemoveFile,
  uploading,
  progress,
  showCloseIcon,
}) {
  return (
    <Stack spacing={3}>
      {files.length === 0 && <AssetUploadDropzone
        files={files}
        onSetFiles={onSetFiles}
        uploading={uploading}
      />}
      <Collapse in={files.length > 0} unmountOnExit>
        <AssetUploadPreviewVerify
          files={files}
          uploading={uploading}
          progress={progress}
          onRemoveFile={onRemoveFile}
          showCloseIcon={showCloseIcon}
        />
      </Collapse>
    </Stack>
  );
}
